import React, { useEffect, useState } from 'react';
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import { themeButtons } from "../../../css/themeButtons";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/styles";
import {
    RenderModalContactDelete,
    RenderModalEditMail,
    RenderModalEditPhone,
    RenderModalImportantContact,
    RenderPhoneBlock
} from "../../ObjectContacts/ObjectContacts";


const useStyles = makeStyles((theme) => ({
  snackbar: {
    bottom: "60px",
    borderRadius: ".25rem",
  },

}));


const FastContacts = (props) => {
  const {
    objectId,
    owner,
    accountant,
    notification,
    goPage,
    messengers,
    getMessengersList,
    paymentType,
    savePage
  } = props

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [])

  //изменяемый контакт
  const [editContact, setEditContact] = useState()

  //удаляемый контакт
  const [removedContact, setRemovedContact] = useState()

  //snackbar ошибка на клиентке
  const [savingErrorMessage, setSavingErrorMessage] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false)
  }


  //состояние модалок, по дефолту скрыты
  let [show, toggleModalShow] = useState({
    modalEditPhone: false,
    modalEditMail: false,
    modalContactDelete: false,
    modalImportantContact: false,
  });

  useEffect(() => {
    if (!messengers) {
      getMessengersList()
    }
  }, [])


  //открытие/закрытие модалок
  const toggleShow = (modalName, type, contactId) => {

    switch (type) {
      case "notification":
        setEditContact(Object.values(notification).flat().filter(item => item.id == contactId)[0])
        break
      case "accountant":
        setEditContact(Object.values(accountant).flat().filter(item => item.id == contactId)[0])
        break
      default:
        setEditContact(Object.values(owner).flat().filter(item => item.id == contactId)[0])
    }


    toggleModalShow({ ...show, [modalName]: !show[modalName] })
  };


  //добавление контакта
  const addNewContact = async (value) => {

    let savedContact = value
    const block = value.phone ? "phones" : "mails"
    const key = value.phone ? "phone" : "email"

    let contactToRemove = {}

    let equalContact = null

    if (key === "phone") {
      equalContact = [...owner[block]].find(item => item[key].replace(/[^\d]/g, '') === value[key].replace(/[^\d]/g, ''))
    } else {
      equalContact = [...owner[block]].find(item => item[key] === value[key])
    }

    if (equalContact && !editContact) {
      setOpenSnackbar(true)
      setSavingErrorMessage("Такой контакт уже добавлен")

      return
    }

    let copyContacts = [...owner[block]].filter(item => item.id !== removedContact?.id && item[key] !== value[key])


    if (removedContact) {
      contactToRemove = { id: removedContact.id, [key]: "" }
    }


    if (key === "phone") {
      let messenger = [value.WA && "WHATSAPP", value.VB && "VIBER"]
      delete savedContact["WA"]
      delete savedContact["VB"]

      savedContact = { ...savedContact, messenger: messenger }
    }

    savedContact = {
      ...savedContact,
      public: savedContact.public ? "Y" : "N",
      accountant: savedContact.accountant ? "Y" : "N",
      notification: savedContact.notification ? "Y" : "N"
    }


    let data = { ...owner, [block]: [...copyContacts, savedContact] }

    if (Object.keys(contactToRemove).length !== 0) {
      data[block].push(contactToRemove)
    }

    await savePage({ object: objectId, section: "contact", data: data })


    setRemovedContact("")

  }

  //удаление старого контакта с заменой на новый
  const removeAndAddNew = (modal) => {

    toggleModalShow((prev) => {
      return {
        ...prev,
        "modalImportantContact": !prev["modalImportantContact"],
        [modal]: !prev[modal]
      }
    })

    setRemovedContact(editContact)
    setEditContact(null)
  }

  //удаление старого контакта с заменой на имеющийся в списке
  const changeImportantContact = (block, contact, importantType) => {


    const itemKey = block === "phones" ? "phone" : "email"

    let removedContact = { id: editContact.id, [itemKey]: '' }
    let changedContact = owner[block].find(item => item[itemKey] === contact)
    let savedContact = owner[block].filter(item => item[itemKey] !== contact && editContact.id !== item.id)

    importantType.map(important => changedContact[important] = "Y")
    savedContact.push(removedContact)
    savedContact.push(changedContact)

    let data = { ...owner, [block]: savedContact }
    savePage({ object: objectId, section: "contact", data: data })


    toggleModalShow((prev) => {
      return {
        ...prev,
        "modalImportantContact": !prev["modalImportantContact"]
      }
    })

  }

  //удаление контакта
  const deleteContact = (contactType) => {

    if (!contactType) {

      let contactToRemove = {}
      if (editContact.phone) {

        contactToRemove = [{ id: editContact.id, phone: "" }]
        let data = {
          ...owner,
          phones: [...owner.phones.filter(item => item.id !== editContact.id), ...contactToRemove]
        }

        savePage({ object: objectId, section: "contact", data: data })

      } else {
        contactToRemove = [{ id: editContact.id, email: "" }]
        let data = {
          ...owner,
          mails: [...owner.phones.filter(item => item.id !== editContact.id), ...contactToRemove]
        }

        savePage({ object: objectId, section: "contact", data: data })
      }

      setEditContact(null)
      toggleModalShow((prev) => {
        return { ...prev, "modalContactDelete": !prev["modalContactDelete"] }
      })
    } else {
      toggleModalShow((prev) => {
        return {
          ...prev,
          "modalContactDelete": !prev["modalContactDelete"],
          "modalImportantContact": !prev["modalImportantContact"]
        }
      })
    }

  }


  const replacementImportantContact = (type, block, newImportantId, oldImportantId) => {

    if (!newImportantId || !type) {
      return
    }

    let updaterContacts = owner[block].map(item => {
      if (item.id == newImportantId) {
        return { ...item, [type]: "Y" }
      }
      if (item.id == oldImportantId) {
        return { ...item, [type]: "N" }
      }
      return item
    })


    let formData = {}
    if (block === "phones") {
      formData = { ...owner, phones: updaterContacts }
    }
    if (block === "mails") {
      formData = { ...owner, mails: updaterContacts }
    }


    savePage({ object: objectId, section: "contact", data: formData })


  }

  const classes = useStyles();

  const buttons = themeButtons()
  return (
    <div className="stepByStepWrp">
      <div className="stepByStepWrp__header">
        <Typography variant="h5" component="h5" className="stepByStepWrp__title">Контакты</Typography>
      </div>


      <div className="stepByStepWrp__body">
        <div className="navbar__object-id badge bg-success me-0 me-sm-2 mb-3">id: {objectId}</div>
        <RenderPhoneBlock type={"owner"}
                          title={"Контакты объекта размещения"}
                          lists={owner}
                          ownerList={owner}
                          messengers={messengers}
                          toggleShow={toggleShow}
                          paymentType={paymentType}
                          replacementImportantContact={replacementImportantContact}/>

        <RenderPhoneBlock type={"notification"}
                          title={"Контакты для уведомлений"}
                          lists={notification}

                          ownerList={owner}
                          messengers={messengers}
                          toggleShow={toggleShow}
                          replacementImportantContact={replacementImportantContact}/>

        <RenderPhoneBlock type={"accountant"}
                          title={"Контакты бухгалтерии"}
                          lists={accountant}

                          ownerList={owner}
                          messengers={messengers}
                          toggleShow={toggleShow}
                          replacementImportantContact={replacementImportantContact}/>


        {show.modalEditPhone && <RenderModalEditPhone toggleShow={() => toggleShow("modalEditPhone")}
                                                      show={show.modalEditPhone}
                                                      ownerList={owner.phones}

                                                      editContact={editContact}
                                                      removedContact={removedContact}
                                                      paymentType={paymentType}
                                                      setEditContact={setEditContact}
                                                      setRemovedContact={setRemovedContact}
                                                      addNewContact={addNewContact}/>}

        {show.modalEditMail && <RenderModalEditMail toggleShow={() => toggleShow("modalEditMail")}
                                                    show={show.modalEditMail}
                                                    ownerList={owner.mails}

                                                    editContact={editContact}
                                                    removedContact={removedContact}
                                                    paymentType={paymentType}
                                                    setEditContact={setEditContact}
                                                    setRemovedContact={setRemovedContact}
                                                    addNewContact={addNewContact}/>}


        {show.modalContactDelete && editContact &&
          <RenderModalContactDelete toggleShow={() => toggleShow("modalContactDelete")}
                                    show={show.modalContactDelete}
                                    editContact={editContact}
                                    deleteContact={deleteContact}/>}


        {show.modalImportantContact && editContact &&
          <RenderModalImportantContact toggleShow={() => toggleShow("modalImportantContact")}
                                       show={show.modalImportantContact}
                                       editContact={editContact}
                                       lists={owner}
                                       removeAndAddNew={removeAndAddNew}
                                       changeImportantContact={changeImportantContact}/>}

        <Snackbar open={openSnackbar} className={classes.snackbar} autoHideDuration={2000}
                  onClose={handleCloseSnackbar}>
          <Alert severity="error">
            {savingErrorMessage ? savingErrorMessage : "Ошибка"}
          </Alert>
        </Snackbar>

      </div>


      <div className="stepByStepWrp__actions">
        <Button className={`btn`} onClick={() => goPage("photos")}>Назад</Button>
        <Button className={`btn ${buttons.btnGreen}`} disabled={owner && owner.phones.length === 0}
                onClick={() => goPage("services")}>Сохранить и продолжить</Button>
      </div>
    </div>


  )
}


export default FastContacts;
